import { t } from '@lingui/macro'
import { formatDateAndTimeLong } from '../../../utils/dateHelpers'
import { IUserActivityCsvResponse } from './DownloadUserActivityCSV'
import { UserDetailAnalyticsQuery } from 'front-end/src/pages/analytics/user-detail/UserDetailAnalytics.codegen'

export const prepareCSVUserActivityExport = (
  rowData,
  user: UserDetailAnalyticsQuery['user']
) =>
  rowData.map((row: IUserActivityCsvResponse) => ({
    [t`Display name`]: user?.last_name,
    [t`Email`]: user?.email,
    [t`First name`]: user?.first_name,
    [t`Last name`]: user?.last_name,
    [t`Account name`]: user?.account_name,
    [t`Last active`]: user?.last_activity_at,
    [t`Resource name`]: row.resourceName,
    [t`Resource ID`]: row.resourceId,
    [t`Views count`]: row.viewsCount,
    [t`Last viewed at`]: formatDateAndTimeLong(row.lastViewedAt),
    [t`Last viewed version`]: row.lastViewedVersion,
    [t`Resource deleted at`]: row.deleted_at,
    [t`User deleted at`]: user?.deleted_at,
    [t`Manager ID`]: user?.manager?.id,
    [t`Manager email`]: user?.manager?.email,
    [t`Manager name`]: user?.manager?.display_name
  }))
